import script from "./RoomDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomDetailView.vue?vue&type=script&setup=true&lang=js"

import "./RoomDetailView.vue?vue&type=style&index=0&id=3aeddd06&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aeddd06"]])

export default __exports__